export default __webpack_public_path__ + "static/media/pikawave2.b505b0e6.png";